import { Component, Schema, type, defaultValue } from "minecs";
@Component()
export class AirportPilot extends Schema {
    @type("number")
    @defaultValue(0)
    index: number;
    @type("number")
    @defaultValue(-1)
    assignedGate: number;
    @type("number")
    @defaultValue(-1)
    flyingGate: number;
    @type("number")
    @defaultValue(0)
    flights: number;
}
